var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42857,
    cy: 1.42857,
    r: 1.42857,
    fill: "#535151"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42857,
    cy: 13.1434,
    r: 1.42857,
    fill: "#535151"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42857,
    cy: 7.28599,
    r: 1.42857,
    fill: "#535151"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.71373,
    cy: 1.42857,
    r: 1.42857,
    fill: "#535151"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.71373,
    cy: 13.1434,
    r: 1.42857,
    fill: "#535151"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.71373,
    cy: 7.28599,
    r: 1.42857,
    fill: "#535151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.e3a8368e579225fc33ee0883766a9afb.svg";
export { ForwardRef as ReactComponent };